<script lang="ts">
export default {
    name: "leftList",
};
</script>
<script setup lang="ts">
import { store } from "@/store"
import { getDeviceTopo1, createFlightTasks } from "@/api/monitorApi/index"
import { Task, FormQuery } from "@/api/monitorApi/types"
import { DeviceTypeName, EBizCode, DroneInDockEnum, RainfallEnum } from '@/types/enum'
import { EModeCode, EDockModeCode, EGear } from '@/types/device'
import { onMounted } from "vue";
import router from '@/router';
import { useVueCesium } from 'vue-cesium'
import type { VcViewerProvider, VcReadyObject } from 'vue-cesium/es/utils/types'
import { flyToCamera } from 'vue-cesium/es/utils/cesium-helpers'

const $vc: VcViewerProvider = useVueCesium()
const str = '--'
const airNumberValue = ref(store.informationListStore.informationStore().airNumberValue)
const airOptions: any = ref([])

const popActive = ref(false)
const pageTop = ref(0)

const organizationData: any = computed(() => store.informationListStore.informationStore().organizationData)

const uavList: any = ref([])
const noUavList: any = ref([])
const droneList: any = ref([])
async function getOnlineTopo() {
    const params: any = {}
    params.page = 1
    params.size = 999
    params.domain = [2,3]
    // params.provinceCode = import.meta.env.VITE_APP_AREACODE,
    //     params.cityCode = organizationData.value.cityCode,
    //     params.areaCode = organizationData.value.areaCode,
    //     params.orgId = organizationData.value.provinceCode,
    // params.domain = 3
    await getDeviceTopo1(params).then((res) => {
        airOptions.value = res.list
        uavList.value = []
        noUavList.value = []
        setTimeout(() => {
            airOptions.value.forEach((item: any) => {
                if(item.domain != 2){
                    if (dockInfo.value[item.deviceSn] && dockInfo.value[item.deviceSn]?.basicOsd?.mode_code !== EDockModeCode.Disconnected) {
                        uavList.value.push(item)
                    } else {
                        noUavList.value.push(item)
                    }
                }else{
                    if (deviceInfo1.value[item.childSn]) {
                        droneList.value.push(item)
                    }
                }
            });
        }, 2000)
    })
}

const airportObj = ref()
const uavObj: any = reactive({
    gateway: {
        capacity_percent: str,
        transmission_signal_quality: str,
    },
    dock: {

    },
    device: {
        gear: -1,
        mode_code: EModeCode.Disconnected,
        height: str,
        home_distance: str,
        horizontal_speed: str,
        vertical_speed: str,
        wind_speed: str,
        wind_direction: str,
        elevation: str,
        position_state: {
            gps_number: str,
            is_fixed: 0,
            rtk_number: str
        },
        battery: {
            capacity_percent: str,
            landing_power: str,
            remain_flight_time: 0,
            return_home_power: str,
        },
        latitude: 0,
        longitude: 0,
    }
})


const workspaceId = localStorage.getItem("Workspace_id") || "";

const formQuery = reactive<FormQuery>({
    name: "",
    file_id: "",
    dock_sn: "",
    task_type: 0,
    rth_altitude: "100", // 相对机场返航高度 20 - 500
    out_of_control: 2,
    is_flight: true,
    execute_time: "",
    select_execute_time: "",
    frequency: "day",
    appoint_time: [],
    wayline_type: 0,
    manual_len: "5",
    auto_detect: false
});


const theEDockModeCode = reactive(['已断开', '空闲中', '调试中', '远程调试', '升级中', '运行中',"待标定"])
const theEModeCode = reactive(['待机', '准备中', '已准备', '手动', '自动', '航点', '全景', '运行轨迹', 'ADS_B', '返航', '着陆', '强制着陆', '三叶着陆', '升级中', '未开机', "APAS", "虚拟摇杆状态", "指令飞行", "空中 RTK 收敛模式", "机场选址中", "POI环绕"])
const osdVisible = computed(() => store.other.useMyStore().getOsdVisible)
// 机场状态
const dockInfo = computed(() => store.other.useMyStore().getDockInfo)
// 无人机状态
const deviceInfo1 = computed(() => store.other.useMyStore().getDeviceStatus)
const deviceInfo: any = reactive({
    gateway: {
        capacity_percent: str,
        transmission_signal_quality: str,
    },
    dock: {

    },
    device: {
        gear: -1,
        mode_code: EModeCode.Disconnected,
        height: str,
        home_distance: str,
        horizontal_speed: str,
        vertical_speed: str,
        wind_speed: str,
        wind_direction: str,
        elevation: str,
        position_state: {
            gps_number: str,
            is_fixed: 0,
            rtk_number: str
        },
        battery: {
            capacity_percent: str,
            landing_power: str,
            remain_flight_time: 0,
            return_home_power: str,
        },
        latitude: 0,
        longitude: 0,
    }
})
const mqttList = ref()

const handleMouseOver = (devicesn: any) => {
    console.log(devicesn)
    airNumberValue.value = devicesn
    store.informationListStore.informationStore().updateInputValue(airNumberValue.value);
    const airObj = airOptions.value.find((obj: any) => obj.deviceSn === airNumberValue.value);
    store.informationListStore.informationStore().setUavObj(airObj);
    if (airObj.deviceSn == '') {
        osdVisible.value.sn = ""
        osdVisible.value.gateway_sn = ""
        osdVisible.value.visible = false
    } else {
        osdVisible.value.sn = airObj.childSn
        osdVisible.value.visible = true
        osdVisible.value.gateway_sn = airObj.deviceSn
        osdVisible.value.gateway_callsign = airObj.nickName
        osdVisible.value.dockControlPanelVisible = false
    }
}

const handleMouseOut = () => {

}

const listBtn = (list: any) => {
    router.push({
        path: "/monitor",
        query: {
            deviceSn: list.deviceSn,
            domain:3
        }
    })
    flyToCamera(
        $vc.viewer,
        {
            position: Cesium.Cartesian3.fromDegrees(list.longitude - 0.0005, list.latitude - 0.083, 5000),
            heading: 6.283185307179586,
            pitch: -0.5001412827126326,
            roll: 6.283185307179586
        },
    )
}

const dronelistBtn = (list: any) => {
    router.push({
        path: "/monitor",
        query: {
            deviceSn: list.deviceSn,
            domain:list.domain
        }
    })
}


const dwBtn = (lng: any, lat: any) => {
    if (lng) {
        $vc.creatingPromise.then((readyObj: VcReadyObject) => {
            flyToCamera(
                $vc.viewer,
                {
                    position: Cesium.Cartesian3.fromDegrees(lng - 0.0005, lat - 0.013, 1000),
                    heading: 6.283185307179586,
                    pitch: -0.5001412827126326,
                    roll: 6.283185307179586
                },
            )
        })
    }
}

watch(() => store.other.useMyStore().deviceState, (data, oldVal) => {
    // console.log(data)
    mqttList.value = data
    if (data.currentType === DeviceTypeName.Aircraft && data.deviceInfo[data.currentSn]) {
        if (osdVisible.value.visible && osdVisible.value.sn !== '') {
            deviceInfo.device = data.deviceInfo[osdVisible.value.sn]
        }
        // console.log('设备状态:', data.deviceInfo)
    }
    if (data.currentType === DeviceTypeName.Dock && data.dockInfo[data.currentSn]) {
        if (osdVisible.value.visible && osdVisible.value.is_dock && osdVisible.value.gateway_sn !== '') {
            deviceInfo.dock = data.dockInfo[osdVisible.value.gateway_sn]
            deviceInfo.device = data.deviceInfo[deviceInfo.dock.basicOsd.subDevice?.device_sn ?? osdVisible.value.sn]
        }
        // console.log('机场状态:', data.dockInfo[data.currentSn])
        // airportIcon.value = data.dockInfo[data.currentSn].basicOsd
        // console.log(airportIcon.value)
    }
}, {
    immediate: true,
    deep: true
})



onMounted(() => {
    getOnlineTopo()
})

</script>

<template>
    <div class="left-monitor">
        <div class="left-block">
            <div class="title-box">
                <p>机库/无人机信息</p>
            </div>
            <div class="task-box">
                <div class="block-date">
                    <span style="color: #fff;font-size: 1.125rem;font-family: AlibabaPuHuiTi;">*在线机场</span>
                </div>
                <div class="air-box">
                    <div v-for="(item, index) in uavList" :key="index">
                        <div class="air-list" @mouseover="handleMouseOver(item.deviceSn)"
                            :class="{ 'airActive': item.deviceSn == airNumberValue }" @mouseout="handleMouseOut"
                            @click.stop="listBtn(item)">
                            <div class="air-name" :title="item.deviceSn">
                                {{ item.nickName }}
                            </div>
                            <div class="dwBtn" @click.stop="dwBtn(item.longitude, item.latitude)">
                                <img src="@/assets/icons/dingwei.png" alt="">
                                <span>定位</span>
                            </div>
                        </div>
                        <div class="air-status-box" v-if="item.deviceSn == airNumberValue">
                            <div class="air-status">
                                <div class="left-box">
                                    <p>
                                        <img src="@/assets/icons/jichang.png" alt="">
                                    </p>
                                    <p>机库</p>
                                    <div class="status-word" :style="dockInfo[osdVisible.gateway_sn] ? dockInfo[osdVisible.gateway_sn].basicOsd?.mode_code == EDockModeCode.Remote_Debugging ?
                                        'color: #FED91B' : dockInfo[osdVisible.gateway_sn].basicOsd?.mode_code !== EDockModeCode.Disconnected ?
                                            'color: #3AFF00' : 'color: #979797'
                                        : 'color: #979797;'">
                                        {{ dockInfo[osdVisible.gateway_sn] ?
                                            theEDockModeCode[dockInfo[osdVisible.gateway_sn].basicOsd?.mode_code +
                                            1] : theEDockModeCode[EDockModeCode.Disconnected + 1] }}
                                    </div>
                                </div>
                            </div>
                            <div class="air-status">
                                <div class="left-box">
                                    <p>
                                        <img src="@/assets/icons/wurenji.png" alt="">
                                    </p>
                                    <p>无人机</p>
                                    <div class="status-word"
                                        :style="deviceInfo1[osdVisible.sn] && deviceInfo1[osdVisible.sn]?.mode_code !== EModeCode.Disconnected ? 'color: #3AFF00' : 'color: #979797;'">
                                        {{ deviceInfo1[osdVisible.sn] ?
                                            theEModeCode[deviceInfo1[osdVisible.sn]?.mode_code]
                                            :
                                            theEModeCode[EModeCode.Disconnected] }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="block-date">
                    <span style="color: #fff;font-size: 1.125rem;font-family: AlibabaPuHuiTi;">*在线飞机</span>
                </div>
                <div class="air-box">
                    <div v-for="(item, index) in droneList" :key="index">
                        <div class="air-list" @mouseover="handleMouseOver(item.deviceSn)"
                            :class="{ 'airActive': item.deviceSn == airNumberValue }" @mouseout="handleMouseOut"
                            @click.stop="dronelistBtn(item)">
                            <div class="air-name" :title="item.deviceSn">
                                {{ item.nickName }}
                            </div>
                            <div class="dwBtn" @click.stop="dwBtn(item.longitude, item.latitude)">
                                <img src="@/assets/icons/dingwei.png" alt="">
                                <span>定位</span>
                            </div>
                        </div>
                        <div class="air-status-box" v-if="item.deviceSn == airNumberValue">
                            <div class="air-status">
                                <div class="left-box">
                                    <p>
                                        <img src="@/assets/icons/jichang.png" alt="">
                                    </p>
                                    <p>机库</p>
                                    <div class="status-word" :style="dockInfo[osdVisible.gateway_sn] ? dockInfo[osdVisible.gateway_sn].basicOsd?.mode_code == EDockModeCode.Remote_Debugging ?
                                        'color: #FED91B' : dockInfo[osdVisible.gateway_sn].basicOsd?.mode_code !== EDockModeCode.Disconnected ?
                                            'color: #3AFF00' : 'color: #979797'
                                        : 'color: #979797;'">
                                        {{ dockInfo[osdVisible.gateway_sn] ?
                                            theEDockModeCode[dockInfo[osdVisible.gateway_sn].basicOsd?.mode_code +
                                            1] : theEDockModeCode[EDockModeCode.Disconnected + 1] }}
                                    </div>
                                </div>
                            </div>
                            <div class="air-status">
                                <div class="left-box">
                                    <p>
                                        <img src="@/assets/icons/wurenji.png" alt="">
                                    </p>
                                    <p>无人机</p>
                                    <div class="status-word"
                                        :style="deviceInfo1[osdVisible.sn] && deviceInfo1[osdVisible.sn]?.mode_code !== EModeCode.Disconnected ? 'color: #3AFF00' : 'color: #979797;'">
                                        {{ deviceInfo1[osdVisible.sn] ?
                                            theEModeCode[deviceInfo1[osdVisible.sn]?.mode_code]
                                            :
                                            theEModeCode[EModeCode.Disconnected] }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="block-date" style="margin-top: 10px;">
                    <span style="color: #fff;font-size: 1.125rem;font-family: AlibabaPuHuiTi;">*不在线机场</span>
                </div>
                <div class="air-box">
                    <div v-for="(item, index) in noUavList" :key="index">
                        <div class="air-list no-air">
                            <div class="air-name" :title="item.deviceSn">
                                {{ item.nickName }}
                            </div>
                            <!-- <div class="dwBtn" @click.stop="dwBtn(item.longitude, item.latitude)">
                                <img src="@/assets/icons/dingwei.png" alt="">
                                <span>定位</span>
                            </div> -->
                        </div>
                        <div class="air-status-box" v-if="item.deviceSn == airNumberValue">
                            <div class="air-status">
                                <div class="left-box">
                                    <p>
                                        <img src="@/assets/icons/jichang.png" alt="">
                                    </p>
                                    <p>机库</p>
                                    <div class="status-word" :style="dockInfo[osdVisible.gateway_sn] ? dockInfo[osdVisible.gateway_sn].basicOsd?.mode_code == EDockModeCode.Remote_Debugging ?
                                        'color: #FED91B' : dockInfo[osdVisible.gateway_sn].basicOsd?.mode_code !== EDockModeCode.Disconnected ?
                                            'color: #3AFF00' : 'color: #979797'
                                        : 'color: #979797;'">
                                        {{ dockInfo[osdVisible.gateway_sn] ?
                                            theEDockModeCode[dockInfo[osdVisible.gateway_sn].basicOsd?.mode_code +
                                            1] : theEDockModeCode[EDockModeCode.Disconnected + 1] }}
                                    </div>
                                </div>
                            </div>
                            <div class="air-status">
                                <div class="left-box">
                                    <p>
                                        <img src="@/assets/icons/wurenji.png" alt="">
                                    </p>
                                    <p>无人机</p>
                                    <div class="status-word"
                                        :style="deviceInfo1[osdVisible.sn] && deviceInfo1[osdVisible.sn]?.mode_code !== EModeCode.Disconnected ? 'color: #3AFF00' : 'color: #979797;'">
                                        {{ deviceInfo1[osdVisible.sn] ?
                                            theEModeCode[deviceInfo1[osdVisible.sn]?.mode_code]
                                            :
                                            theEModeCode[EModeCode.Disconnected] }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.left-monitor {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 29.2vw;
    height: 100vh;
    background: url("@/assets/icons/left-bg.png") no-repeat center;
    background-size: 100% 100%;
    z-index: 1;


    .left-block {
        // margin-left: 19px;
        margin-top: 7.6vh;

        .title-box {
            width: 19.5vw;
            height: 2.5vh;
            background: url("@/assets/icons/title-bg.png") center no-repeat;
            background-size: cover;
            margin-left: .7vw;

            p:nth-child(1) {
                font-family: YouSheBiaoTiHei;
                font-size: 1.125rem;
                font-weight: normal;
                color: #fff;
                margin: 0 0 0 1.5vw;
                line-height: 2.1vh;
            }
        }
    }

    .task-box {
        width: 19vw;
        height: 85vh;
        overflow-y: auto;
        margin-left: 1.5vw;
        pointer-events: all;
        .block-date {
            margin: .7vh 0 0 0;
        }

        .air-box {
            width: 17.5vw;
            padding-top: .5vh;

            .air-list {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 18.2vw;
                height: 3vh;
                background: linear-gradient(270deg, rgba(73, 72, 79, 0.19) 0%, rgba(89, 83, 132, 0.19) 100%);
                box-sizing: border-box;
                border: 1px solid;
                border-radius: 3px;
                border-image: linear-gradient(270deg, rgba(136, 141, 141, 0.38) 0%, rgba(136, 141, 141, 0.55) 97%) 1;
                margin-top: 10px;
                cursor: pointer;

                .air-name {
                    width: 10.4vw;
                    font-size: .875rem;
                    color: #fff;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                    margin-left: .625rem;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    font-family: AlibabaPuHuiTi;
                }

                .dwBtn {
                    display: flex;
                    align-items: center;
                    color: #0BE8F6;
                    margin-right: .625rem;
                    font-size: .875rem;
                    font-family: AlibabaPuHuiTi;
                    cursor: pointer;

                    img {
                        width: .8vw;
                        height: 1.5vh;
                        margin-right: 2px;
                    }
                }
            }

            .no-air {
                border: 1px solid rgb(160, 160, 160 ,0.5);
                border-radius: 3px;
                cursor: auto;
            }

            .airActive {
                background: rgba(124, 135, 161, 0.2);
                box-sizing: border-box;
                border: 1px solid #0BE8F6;
            }

            .air-status-box {
                width: 18.2vw;
                height: 18.1vh;
                display: flex;
                justify-content: space-around;
                align-items: center;
                background: linear-gradient(0deg, rgba(21, 154, 255, 0.106) 0%, rgba(21, 154, 255, 0.2) 100%);
                box-sizing: border-box;
                border: 1px solid;
                border-image: linear-gradient(180deg, rgba(111, 236, 255, 0.3) 16%, rgba(21, 154, 255, 0) 100%) 1;

                .air-status {
                    display: flex;
                    align-items: center;

                    .left-box {
                        p:nth-child(1) {
                            width: 5vw;
                            height: 8.7vh;

                            img {
                                width: 100%;
                                height: 100%;
                            }
                        }

                        p:nth-child(2) {
                            font-family: YouSheBiaoTiHei;
                            font-size: 1.125rem;
                            font-weight: normal;
                            letter-spacing: 0em;
                            font-variation-settings: "opsz" auto;
                            color: #FFFFFF;
                            margin: .5vh 0;
                        }

                        p {
                            text-align: center;
                            color: #fff;
                        }

                        .status-word {
                            font-size: .75rem;
                            text-align: center;
                            color: #fff;
                            font-family: AlibabaPuHuiTi;
                        }
                    }

                }
            }
        }

        .task-list-bj {
            width: 18vw;
            height: 53vh;
            margin: .625rem 0;
            margin-left: 10px;
            overflow-y: auto;

            .list-box {
                width: 90%;
                height: 14vh;
                background-color: rgba(0, 0, 0, 0.36);
                margin: 0.6rem auto;
                border-radius: 5px;
                border: 1px solid #bcc5cb;
                display: flex;
                flex-direction: column;
                justify-content: center;
                position: relative;
                cursor: pointer;

                p {
                    font-size: 1rem;
                    color: #fff;
                    margin: .3125rem 1.25rem;
                    white-space: nowrap;
                    /* 确保文本在一行内显示 */
                    overflow: hidden;
                    /* 隐藏溢出的内容 */
                    text-overflow: ellipsis;
                    /* 使用省略号表示文本溢出 */
                    // line-height: normal;
                }

                .statusWord {
                    width: 10vw;
                }

                .executeBtn {
                    position: absolute;
                    right: 10px;
                    bottom: 2px;
                    background-color: #00A8FF;
                    border-radius: 5px;
                    padding: 5px 10px;
                    cursor: pointer;

                }
            }
        }

    }

}
</style>
